export default __webpack_public_path__ + "static/media/mygivingIntro.24b8a9f2.mp4";